var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperatorInterfaceSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 200,
    viewBox: "0 0 251 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.5 64a7 7 0 110 14h64a7 7 0 110 14h22a7 7 0 110 14h-19a7 7 0 100 14h6a7 7 0 110 14h-146a7 7 0 110-14h-39a7 7 0 110-14h40a7 7 0 100-14h-25a7 7 0 110-14h40a7 7 0 110-14h57zm90 56a7 7 0 110 14 7 7 0 010-14z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.373 142.119c3.038-1.955 5.739-4.394 7.497-6.363l-7.497 6.363zm10.332-9.636a47.506 47.506 0 003.92-5.569 47.688 47.688 0 005.512-13.487 48.297 48.297 0 00-1.327-27.01 47.922 47.922 0 00-5.843-11.546 48.711 48.711 0 00-5.06-6.18 48.46 48.46 0 00-9.023-7.343 47.948 47.948 0 00-10.949-5.102 48.327 48.327 0 00-26.156-.926 47.6 47.6 0 00-12.257 4.868 47.936 47.936 0 00-9.604 7.198A47.814 47.814 0 0080.89 79.35a47.763 47.763 0 00-4.719 13.37 48.342 48.342 0 00-.582 14.457 48.06 48.06 0 0013.261 28.203 48.156 48.156 0 0016.346 11.122 48.305 48.305 0 0022.849 3.412 47.793 47.793 0 0018.706-5.759",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.705 132.483a47.506 47.506 0 003.92-5.569 47.688 47.688 0 005.512-13.487 48.297 48.297 0 00-1.327-27.01 47.922 47.922 0 00-5.843-11.546 48.711 48.711 0 00-5.06-6.18 48.46 48.46 0 00-9.023-7.343 47.948 47.948 0 00-10.949-5.102 48.33 48.33 0 00-26.156-.926 47.603 47.603 0 00-12.257 4.868 47.932 47.932 0 00-9.604 7.198A47.814 47.814 0 0080.89 79.35a47.763 47.763 0 00-4.719 13.37 48.342 48.342 0 00-.582 14.457 48.06 48.06 0 0013.261 28.203 48.156 48.156 0 0016.346 11.122 48.305 48.305 0 0022.849 3.412 47.793 47.793 0 0018.706-5.759m3.622-2.035c3.038-1.955 5.739-4.394 7.497-6.363l-7.497 6.363z",
    stroke: "#12B76A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 45v6",
    stroke: "#6CE9A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170 59v6",
    stroke: "#6CE9A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160 55h6",
    stroke: "#6CE9A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174 55h6",
    stroke: "#6CE9A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87 148v4",
    stroke: "#6CE9A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87 160v4",
    stroke: "#6CE9A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79 156h4",
    stroke: "#6CE9A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91 156h4",
    stroke: "#6CE9A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.682 62.7a41.569 41.569 0 00-5.954 2.79 41.93 41.93 0 00-8.404 6.298 42.327 42.327 0 00-2.985 3.195L108.682 62.7zM88.464 78.827a41.553 41.553 0 00-3.318 6.054",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.464 78.826a41.553 41.553 0 00-3.318 6.054m23.536-22.18a41.569 41.569 0 00-5.954 2.79 41.93 41.93 0 00-8.404 6.298 42.327 42.327 0 00-2.985 3.195L108.682 62.7z",
    stroke: "#6CE9A6",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.48 101.369a3.606 3.606 0 00-5.045.224 3.488 3.488 0 00.228 4.976l16.808 15.141c2.039 1.836 5.201 1.695 7.064-.315.078-.086.078-.086.153-.173l23.987-28.448a3.489 3.489 0 00-.463-4.96 3.607 3.607 0 00-5.03.456l-22.551 26.746-15.151-13.647z",
    fill: "#D1FADF",
    stroke: "#12B76A",
    strokeWidth: 2.5
  })));
}
export default SvgOperatorInterfaceSuccess;